/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "onboard": {
        "nested": {
          "activation": {
            "nested": {
              "es": {
                "nested": {
                  "model": {
                    "nested": {
                      "Business": {
                        "fields": {
                          "type": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "businessName": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "businessAddressToken": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "vatNumber": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "vatName": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          },
                          "vatAddress": {
                            "type": "string",
                            "id": 6,
                            "rule": "optional"
                          },
                          "vatCountryCode": {
                            "type": "string",
                            "id": 7,
                            "rule": "optional"
                          },
                          "taxIdentificationNumber": {
                            "type": "string",
                            "id": 8,
                            "rule": "optional"
                          },
                          "countryOfRegistration": {
                            "type": "string",
                            "id": 9,
                            "rule": "optional"
                          },
                          "tradingName": {
                            "type": "string",
                            "id": 10,
                            "rule": "optional"
                          },
                          "tradingAddressToken": {
                            "type": "string",
                            "id": 11,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.es?.nested?.model?.nested?.Business) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE Business @ squareup/onboard/activation/es/model.proto at 10:1
 */
export const Business = $root.lookupType('squareup.onboard.activation.es.model.Business');
fixType(Business);
Builder.createAndAttachToType(Business);